import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, notification, Button } from 'antd';

// Providers
import { AuthProvider, AuthGuard } from './shared/contexts/AuthContext';
import { ErrorProvider } from './shared/contexts/ErrorContext';
import { ApiProvider } from './shared/contexts/ApiContext';

// Layout
import AppLayout from './shared/layout/AppLayout';

// Error Pages
import NotFoundPage from './pages/error/NotFoundPage';

// Pages
import LoginPage from './pages/login/LoginPage';
import PaymentPage from './pages/payments/PaymentPage';
import PaymentListPage from './pages/payments/PaymentListPage';

// Utils
import { startVersionCheck, APP_VERSION } from './shared/utils/versionCheck';

const ProtectedApp = () => (
  <AppLayout />
);

const App: React.FC = () => {
  useEffect(() => {
    console.log('App version:', APP_VERSION);

    // Start version checking
    const stopVersionCheck = startVersionCheck(() => {
      notification.warning({
        message: 'Доступна новая версия',
        description: 'Доступна новая версия приложения. Пожалуйста, обновите страницу.',
        duration: 0,
        btn: (
          <Button
            type="primary"
            size="small"
            onClick={() => window.location.reload()}
          >
            Обновить
          </Button>
        ),
        key: 'version-update',
      });
    });

    return () => stopVersionCheck();
  }, []);

  return (
    <ConfigProvider renderEmpty={() => null}>
      <ErrorProvider>
        <AuthProvider>
          <ApiProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />

              {/* Protected Application Routes */}
              <Route path="/app" element={<AuthGuard />}>
                <Route element={<ProtectedApp />}>
                  <Route index element={<Navigate to="pay-onay" replace />} />
                  <Route path="pay-onay" element={<PaymentPage />} />
                  <Route path="payments" element={<PaymentListPage />} />
                </Route>
              </Route>

              {/* Redirect root path to /app or /login based on auth */}
              <Route path="/" element={<Navigate to="/app" replace />} />

              {/* Fallback for any other route - Not Found */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </ApiProvider>
        </AuthProvider>
      </ErrorProvider>
    </ConfigProvider>
  );
};

export default App;
